const App = () => {
  return (
    <svg width="21" height="21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        opacity=".4"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 2.5a2.5 2.5 0 1 0 5 0 2.5 2.5 0 0 0-5 0ZM2.5 13a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5Zm0 8a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5Zm8 0a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5Zm5.5-2.5a2.5 2.5 0 1 0 5 0 2.5 2.5 0 0 0-5 0ZM10.5 13a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5ZM8 2.5a2.5 2.5 0 1 0 5 0 2.5 2.5 0 0 0-5 0ZM18.5 13a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5ZM16 2.5a2.5 2.5 0 1 0 5 0 2.5 2.5 0 0 0-5 0Z"
        fill="#fff"
      />
    </svg>
  );
};

export default App;
